import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ScheduleService from "../../../services/KangarooServices/ScheduleService";
import ScheduleBreakForm from "../component/ScheduleBreakForm";
import WorkingScheduleForm from "../component/WorkingScheduleForm";
// import UserForm from "../component/UserForm";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const DAYS = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];

const WorkingSchedule = () => {
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = (item) => {
    setSelectedCustomer(item);
    setIsModalOpen(!isModalOpen);
  };
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const fetchdata = async () => {
    try {
      const data = await ScheduleService.getWorkingList();
      setdata(data);
      console.log("Fetched user:", data);
    } catch (error) {
      console.error("Error getting user:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchdata();
  }, []);
  console.log("data");

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Day Of Week",
      selector: (row) => {
        const day = DAYS.find((d) => d.value === row.dayOfWeek);
        return day ? day.label : "N/A";
      },
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row.isActive,
      sortable: true,
      cell: (row) => (
        <Badge color={row.isActive ? "success" : "danger"}>
          {row.isActive ? "Active" : "Inactive"}
        </Badge>
      ),
    },

    {
      name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => toggleModal(row)}
          >
            <i className="ri-edit-line" />
          </Button>
          {/* <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button> */}
        </div>
      ),
      center: true,
    },
  ];

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedCustomer(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedCustomer) {
      try {
        await ScheduleService.delete(selectedCustomer);
        setCustomerList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedCustomer)
        );
        toast.success("Selected customer deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedCustomer(null);
      }
    }
  };
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Schedule Break" pageTitle="Schedule Management" />
      </div>
      {/* <Row>
        <Col md={8} xs={10} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by name, email & phone number"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-lg-flex d-none justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success px-1 px-sm-2"
            onClick={toggleModal}
          >
            + Add User
          </button>
        </Col>
      </Row> */}
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={data}
          />
        </CardBody>
      </Card>

      <WorkingScheduleForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedItem={selectedCustomer}
        fetchdata={fetchdata}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedCustomer} // Pass the selected item
      />
    </div>
  );
};

export default WorkingSchedule;
